import React, { useContext, useState } from 'react'
import icon from '../../../assets/shareholdersIcon.png'
import CustomInput from '../../../components/CustomInputs/CustomInput'
import { Button } from 'flowbite-react'
import client from '../../../api/client'
import { UserContext } from '../../../contexts/UserContext'
import showToast from '../../../components/CustomToast/toastHelper'
const CreateVirtualWallet = () => {
    const {userDetails} =useContext(UserContext) ?? {}
    
    const [inputs, setInputs] = useState({
        bvn: ""
    });

    const disableFunction = () => {
        return !(inputs.bvn);
    };
    let disabled = disableFunction();

    const updateProps = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        const inputName = event.target.name;
        setInputs((prevState: any) => {
            return {
                ...prevState,
                [inputName]: newValue,
            };
        });
    };

    const createWallet = async() => {
        const payload = {
            bvn:inputs.bvn,
        }

        try {
            const response = await client.post('/subsidiary/create/static/account',payload);
      
            // setBanks(response.data.banks);
            const message = response?.data?.message;
            showToast(message,"success")
          } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
              sessionStorage.clear();
              window.location.href = '/';
            } else {
              const message = err?.response?.data?.message;
              console.error('error getting data', err);
              showToast(message,"error")
            }
          }
    }
    return (
        <div>
            <div>
                <img src={icon} className='my-3' />
                <div className='my-3'>
                    <p className='text-xl font-bold'>Create Virtual Wallet</p>
                    <p className='text-sm'>Kindly fill in information needed</p>
                </div>
                <div>
                    <CustomInput label='BVN' name='bvn' value={inputs.bvn}
                        onChange={updateProps} />
                </div>
                <div className='flex gap-4'>
                    <Button className='w-1/4' outline>Cancel</Button>
                    <Button
                        className={`w-3/4 text-black hover:text-white ${disabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-custom-button-green'}`}
                        disabled={disabled} onClick={() => createWallet()}
                    >
                        Create Virtual Wallet
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default CreateVirtualWallet
